// extracted by mini-css-extract-plugin
module.exports = {"message":"message_message__AB8A2"};